import React, { useState } from "react";
import { MdDocumentScanner, MdPeopleAlt } from "react-icons/md";

function Legal() {
  const [activeStep, setActiveStep] = useState(1);

  return (
    <div className="my_account general">
      <div className="tabs_area">
        <div className="steps">
          <button
            className={`step ${activeStep === 1 ? "active" : ""}`}
            onClick={() => setActiveStep(1)}
            disabled={false}
            aria-label="Step 1: Documents"
          >
            <MdDocumentScanner className="icons" /> Terms of Service
          </button>
          <button
            className={`step ${activeStep === 2 ? "active" : ""}`}
            onClick={() => setActiveStep(2)}
            disabled={false}
            aria-label="Step 2: Refer a Friend"
          >
            <MdPeopleAlt className="icons" /> Privacy Policy
          </button>
        </div>
        <div className="step-container">
          <div className="step-content">
            {activeStep === 1 && (
              <>
                <div className="tabs_card">
                  <div className="header">
                    <h4>Copy & Paste Everything from this Link:</h4>
                  </div>
                  <div className="content">
                    <p>https://www.cassowealth.com/terms-and-coniditions</p>
                  </div>
                </div>
              </>
            )}
            {activeStep === 2 && (
              <div className="tabs_card">
                <div className="header">
                  <h4>Copy & Paste Everything from this Link:</h4>
                </div>
                <div className="content">
                  <p>https://www.cassowealth.com/terms-and-coniditions</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Legal;
